import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

// Flattened helper array for role types
const roleTypeOptions = [
  { value: "", label: "Select" },
  { value: "INDIVIDUAL", label: "Individual" },
  { value: "CORPORATE", label: "Corporate" },
  { value: "TRADER_CHANNEL_PARTNER", label: "Trader/Channel Partner" },
  { value: "INSURANCE", label: "Insurance" },
  { value: "LAW_ENFORCEMENT", label: "Law Enforcement" },
  { value: "LAW_ENFORCEMENT_ADMINISTRATOR", label: "Law Enforcement Admin" },
  { value: "ADMINISTRATOR", label: "Administrator" },
  { value: "FINANCE", label: "Finance" },
];

const initialRole = {
  id: 0,
  name: "",
  activeStatus: "YES",
  roleType: "INDIVIDUAL",
  roleMenus: [],
};

export default class RoleSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,valid:false,
      msg: "",
      toastColor: "",
      roles: [],
      allMenus: [],
      role: initialRole,
      errors: {},
      page: 0,
      size: 10,
      totalPages: 1,
      editing: false,
      menuPopup: false,
    };
    this.handleRoleChange = this.handleRoleChange.bind(this);
    this.handleRoleMenuChange = this.handleRoleMenuChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleShowMenus = this.handleShowMenus.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.handleBackFromMenus = this.handleBackFromMenus.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchRoles = this.fetchRoles.bind(this);
    this.fetchMenus = this.fetchMenus.bind(this);
    this.fetchRoleById = this.fetchRoleById.bind(this);
    this.handlePreviousPage = this.handlePreviousPage.bind(this);
    this.handleNextPage = this.handleNextPage.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No User Token",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    this.fetchRoles(0, 10, token);
    this.fetchMenus(token);
  }

  fetchRoles(page, size, token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/settings/getroles", {
        params: { page, size },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let roles = [];
        let totalPages = 1;
        if (response.data && Array.isArray(response.data)) {
          roles = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          roles = response.data.content;
          totalPages = response.data.totalPages || 1;
        } else {
          roles = [];
        }
        this.setState({
          roles,
          page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          roles: [],
          totalPages: 1,
          loading: false,
          msg: error?.response?.data?.message || "Failed to load roles.",
          toastColor: "danger",
        });
      });
  }

  fetchMenus(token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + `/settings/getrolebyid/0`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        this.setState({
          allMenus: response.data.menu || [],
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          allMenus: [],
          loading: false,
          msg: error?.response?.data?.message || "Failed to load menus.",
          toastColor: "danger",
        });
      });
  }

  fetchRoleById(id, token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + `/settings/getrolebyid/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data) {
          this.setState({
            role: response.data,
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg: error?.response?.data?.message || "Failed to load role.",
          toastColor: "danger",
        });
      });
  }

  handleRoleChange(field, value) {
    this.setState(
      (prevState) => ({
        role: { ...prevState.role, [field]: value },
      }),
      this.validate
    );
  }

  handleRoleMenuChange(menuId, checked) {
    this.setState((prevState) => {
      let roleMenus = [...prevState.role.roleMenus];
      if (checked) {
        if (!roleMenus.some((rm) => rm.menuId === menuId)) {
          const menu = prevState.allMenus.find((m) => m.id === menuId);
          if (menu) {
            roleMenus.push({
              id: 0,
              activeStatus: "YES",
              roleId: prevState.role.id,
              menuId: menu.id,
              menuName: menu.name,
            });
          }
        }
      } else {
        roleMenus = roleMenus.filter((rm) => rm.menuId !== menuId);
      }
      const newRole = { ...prevState.role, roleMenus };
      return { role: newRole };
    }, this.validate);
  }

  validate() {
    const role = this.state.role;
    const errors = {};
    let valid = true;

    if (!role.name || !role.name.trim()) {
      errors.name = "Role name is required";
      valid = false;
    }
    if (!role.activeStatus || !role.activeStatus.trim()) {
      errors.activeStatus = "Active status is required";
      valid = false;
    }
    if (!role.roleType || !role.roleType.trim()) {
      errors.roleType = "Role type is required";
      valid = false;
    }

    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    const self = this;
    axios
      .post(API + "/settings/rolesave", this.state.role, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: "Role saved successfully!",
            toastColor: "success",
            loading: false,
          });
          self.fetchRoles(self.state.page, self.state.size, token);
          self.setState({ role: initialRole, editing: false, errors: {} });
        } else {
          self.setState({
            msg: response.data.message || "Failed to save role.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save role. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(roleView) {
    const token = sessionStorage.getItem("token");
    if (roleView && roleView.id > 0) {
      this.fetchRoleById(roleView.id, token);
    } else {
      this.setState({ role: initialRole });
    }
    this.setState(
      { editing: true, menuPopup: false, errors: {} },
      this.validate
    );
  }

  handleShowMenus(roleView) {
    const token = sessionStorage.getItem("token");
    this.fetchRoleById(roleView.id, token);
    this.setState({ menuPopup: true, editing: false });
  }

  handleCancelEdit() {
    this.setState({
      role: initialRole,
      editing: false,
      menuPopup: false,
      errors: {},
    });
  }

  handleBackFromMenus() {
    this.setState({ menuPopup: false });
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      const token = sessionStorage.getItem("token");
      this.fetchRoles(this.state.page - 1, this.state.size, token);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      const token = sessionStorage.getItem("token");
      this.fetchRoles(this.state.page + 1, this.state.size, token);
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title="Role Settings" />
          {divMsg}
          <div className="d-flex flex-column flex-grow-1 px-5 h-60">
            {s.editing ? (
              // Edit/Add form
              <form
                className="d-flex flex-column align-items-center w-100 mt-2 pt-3 pb-2 h-100 overflow-auto"
                autoComplete="off"
                onSubmit={this.handleSave}
              >
                <div className="row g-3 w-100" style={{maxWidth: 62 + 'rem'}}>
                  <div className="input-group">
                    <label className="input-group-text">Role Name</label>
                    <input
                      name="name"
                      className={`form-control ${
                        s.errors.name ? " !border-red-500" : ""
                      }`}
                      value={s.role.name}
                      onChange={(e) =>
                        this.handleRoleChange("name", e.target.value)
                      }
                      required
                      autoFocus
                    />
                    {s.errors.name && (
                      <span className="input-group-error">{s.errors.name}</span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Active Status</label>
                    <select
                      name="activeStatus"
                      className={`form-control ${
                        s.errors.activeStatus ? " !border-red-500" : ""
                      }`}
                      value={s.role.activeStatus}
                      onChange={(e) =>
                        this.handleRoleChange("activeStatus", e.target.value)
                      }
                      required
                    >
                      <option value="">Select</option>
                      <option value="YES">Yes</option>
                      <option value="NO">No</option>
                    </select>
                    {s.errors.activeStatus && (
                      <span className="input-group-error">
                        {s.errors.activeStatus}
                      </span>
                    )}
                  </div>
                  <div className="input-group">
                    <label className="input-group-text">Role Type</label>
                    <select
                      name="roleType"
                      className={`form-control ${
                        s.errors.roleType ? " !border-red-500" : ""
                      }`}
                      value={s.role.roleType}
                      onChange={(e) =>
                        this.handleRoleChange("roleType", e.target.value)
                      }
                      required
                    >
                      <option value="">Select</option>
                      {roleTypeOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>
                          {opt.label}
                        </option>
                      ))}
                    </select>
                    {s.errors.roleType && (
                      <span className="input-group-error">
                        {s.errors.roleType}
                      </span>
                    )}
                  </div>
                </div>
                <div className="d-flex flex-column w-100 mt-4">
                  <label className="input-group-text mb-2">Assign Menus</label>
                  <div className="overflow-x-auto w-full border h-48 relative overflow-y-auto">
                    <table className="min-w-full divide-y divide-gray-200 table table-striped table-hover rounded-md">
                      <thead className="table-primary">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Assign
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Menu Function
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Active Status
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {s.allMenus.map((menu, index) => (
                          <tr key={index}>
                            <td className="px-6 py-4">
                              <input
                                type="checkbox"
                                checked={s.role.roleMenus.some(
                                  (rm) => rm.menuId === menu.id
                                )}
                                onChange={(e) =>
                                  this.handleRoleMenuChange(
                                    menu.id,
                                    e.target.checked
                                  )
                                }
                              />
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {menu.id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {menu.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {menu.menuFunction}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {menu.activeStatus}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="d-flex justify-content-center gap-3 mt-4">
                  {s.valid && (
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  )}
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : (
              // Table View
              <div className="h-full w-full">
                {!s.menuPopup ? (
                  <>
                    <div className="flex gap-2 mb-2 items-baseline justify-between">
                      <h3 className="fw-bold">Configured Roles</h3>
                      <button
                        className="hover:font-bold flex gap-1 group"
                        onClick={() => this.handleEdit(null)}
                      >
                        <i
                          className="bi bi-plus-circle group-hover:scale-105"
                          style={{ color: "black" }}
                        ></i>
                        Add
                      </button>
                    </div>
                    {s.roles?.length === 0 ? (
                      <div className="text-muted">No roles found.</div>
                    ) : (
                      <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                        <table className="min-w-full divide-y divide-gray-200 table table-striped table-hover rounded-md">
                          <thead className="bg-gray-50 sticky top-0">
                            <tr>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                ID
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Name
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Active Status
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Actions
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {s.roles?.map((group, index) => (
                              <tr key={index} className="hover:bg-gray-50">
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {group.id}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {group.name}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {group.activeStatus}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                                  <button
                                    className="btn btn-primary mr-2"
                                    onClick={() => this.handleShowMenus(group)}
                                  >
                                    Show Menus
                                  </button>
                                  <button
                                    className="btn btn-primary"
                                    onClick={() => this.handleEdit(group)}
                                  >
                                    Edit
                                  </button>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {s.totalPages > 1 && (
                      <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                        <button
                          className="btn btn-outline"
                          disabled={s.page === 0}
                          onClick={this.handlePreviousPage}
                        >
                          Previous
                        </button>
                        <span>
                          Page {s.page + 1} of {s.totalPages}
                        </span>
                        <button
                          className="btn btn-outline"
                          disabled={s.page + 1 >= s.totalPages}
                          onClick={this.handleNextPage}
                        >
                          Next
                        </button>
                      </div>
                    )}
                  </>
                ) : (
                  // Menus View
                  <>
                    <div className="flex gap-2 mb-2 items-baseline justify-between">
                      <h3 className="font-bold">
                        Configured Menus for Role '{s.role.name}'
                      </h3>
                      <button
                        className="btn btn-primary"
                        onClick={this.handleBackFromMenus}
                      >
                        Back
                      </button>
                    </div>
                    {s.role.roleMenus.length === 0 ? (
                      <div className="text-gray-500">No menus found.</div>
                    ) : (
                      <div className="overflow-x-auto w-full border h-[90%] relative overflow-y-auto">
                        <table className="min-w-full divide-y divide-gray-200 table table-striped table-hover rounded-md">
                          <thead className="bg-gray-50 sticky top-0">
                            <tr>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Menu ID
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Menu Name
                              </th>
                              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                Active Status
                              </th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {s.role.roleMenus.map((rm, index) => (
                              <tr key={index}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {rm.menuId}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {rm.menuName}
                                </td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                  {rm.activeStatus}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </>
                )}
              </div>
            )}
          </div>
          
        </div>
      </div>
    );
  }
}
